import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  InputAdornment,
  FormGroup,
  FormControlLabel,
  Avatar,
  Typography,
  Box,
  CircularProgress,
  Paper,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Chip,
  Autocomplete,
  MenuItem,
} from "@mui/material";
import { motion } from "framer-motion";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import UpdateIcon from "@mui/icons-material/Update";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import Swal from "sweetalert2";
import configServ from "../../services/config";
import { useSelector } from "react-redux";
import IOSSwitch from "../../Components/Buttons/IOSSwitch";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { toast } from "react-hot-toast";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Edit, Delete, Download } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import LoaderBackdrop from "../../Components/Loader/LoaderBackdrop";
import FileNameDialog from "../../Components/FileNameDialog/FileNameDialog";
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import UploadPdfDialog from "../../Components/UploadChunksPdf/UploadPdfDialog";

const Dharohar = () => {
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { company_id, user_id } = useSelector((state) => state.GlobalVariables);
  const [backDrowLoading, setBackDrowLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [bookImage, setBookImage] = useState(null);

  const category_id = 100;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [download_file, setDownload_file] = useState(null);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [formData, setFormData] = useState({
    name: "",
    podcaster_id: null,
    podcast_url: "",
    book_image: "",
    active: true,
  });

  const [previewImage, setPreviewImage] = useState(null);
  const [isPodcasterName, setIsPodcasterName] = useState(false);
  const [podcastList, setPodcastList] = useState([]);
  const [podcastUser, setPodcastUser] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [searchField, setSearchField] = useState("name"); // default search by name
  const handlePopup = () => {
    setIsCreate(!isCreate);
    setIsEdit(false);
    clear();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Remove validation error for that specific field when user types
    setValidationErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const clear = () => {
    setFormData({
      name: "",
      podcaster_id: null,
      podcast_url: "",
      active: true,
      book_image: "",
    });
    setBookImage(null);
    setIsEdit(false);
    setValidationErrors({});
    setDownload_file(null);
  };

  // API Call to check podcaster name

  const handleSubmit = async () => {
    const errors = {};

    // Name required
    if (!formData.name?.trim()) {
      errors.name = "Name is required";
    }

    // Podcaster required
    if (!formData.podcaster_id) {
      errors.podcaster_id = "Podcaster is required";
    }

    // URL required & format check
    if (!formData.podcast_url?.trim()) {
      errors.podcast_url = "Podcast URL is required";
    } else {
      // Simple regex for URL validation
      const urlPattern = /^(https?:\/\/)([^\s$.?#].[^\s]*)$/i;
      if (!urlPattern.test(formData.podcast_url.trim())) {
        errors.podcast_url =
          "Enter a valid URL (must start with http:// or https://)";
      }
    }

    // If there are errors, set and stop submit
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    setValidationErrors({});

    try {
      setBackDrowLoading(true);
      let res;
      if (isEdit) {
        res = await configServ.updateResourceDetails(formData.id, {
          ...formData,
          company_id,
          category_id: category_id,
          updated_by: user_id,
        });
      } else {
        res = await configServ.createResoureceDetails({
          ...formData,
          company_id,
          category_id,
          created_by: user_id,
        });
      }

      if (res.success) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: res.message || (isEdit ? "book updated!" : "book created!"),
          timer: 2000,
          showConfirmButton: false,
        });
        clear();
        setIsCreate(false);
        fetchPodcasts();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Something went wrong!",
      });
    } finally {
      setBackDrowLoading(false);
    }
  };

  // const onEdit = async (item) => {
  //   try {
  //     console.log("onEdit=", item);

  //     setIsCreate(true);
  //     setIsEdit(true);

  //     // Step 1️⃣ — Fetch Dharohar Images
  //     const res = await configServ.getBookImagesByResourceId({
  //       id: item.id,
  //     });

  //     if (res?.success && res.data.length > 0) {
  //       const firstImage = res.data[0]; // assuming one image per resource
  //       const base64 = firstImage.image_path;

  //       // Detect MIME type
  //       const match = base64.match(/^data:(.*?);base64,/);
  //       const mimeType = match ? match[1] : "";

  //       // Step 2️⃣ — Store in state for preview
  //       setBookImage({
  //         base64,
  //         preview: { type: mimeType },
  //       });

  //       // Step 3️⃣ — Also update formData for submission
  //       setFormData({
  //         ...item,
  //         podcaster_id: item.resource_id
  //           ? parseInt(item.resource_id, 10)
  //           : null,
  //         podcast_url: item.url || "",
  //         url: item.web_url || "",
  //         active: item.active === 1 ? true : false,
  //         book_image: base64,
  //       });
  //     } else {
  //       // If no image found, still set the form
  //       setBookImage(null);
  //       setFormData({
  //         ...item,
  //         podcaster_id: item.resource_id
  //           ? parseInt(item.resource_id, 10)
  //           : null,
  //         podcast_url: item.url || "",
  //         url: item.web_url || "",
  //         active: item.active === 1 ? true : false,
  //         book_image: null,
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching Dharohar images:", error);
  //   }
  // };

  const onEdit = async (item) => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    setBackDrowLoading(true);
    try {
      // console.log("onEdit =", item);

      setIsCreate(true);
      setIsEdit(true);

      // Step 1️⃣ — Default form setup first (so always works)
      const baseFormData = {
        ...item,
        podcaster_id: item.resource_id ? parseInt(item.resource_id, 10) : null,
        podcast_url: item.url || "",
        url: item.web_url || "",
        active: item.active === 1 ? true : false,
        book_image: null,
      };

      // Step 2️⃣ — Set default data before fetching image
      setFormData(baseFormData);
      setBookImage(null);

      // Step 3️⃣ — Try fetching image
      const res = await configServ.getBookImagesByResourceId({
        id: item.id,
      });

      if (res?.success && Array.isArray(res.data) && res.data.length > 0) {
        const firstImage = res.data[0];
        const base64 = firstImage.image_path;
        setDownload_file(firstImage.download_file);


        // Detect MIME type
        const match = base64.match(/^data:(.*?);base64,/);
        const mimeType = match ? match[1] : "";

        // ✅ Update image state
        setBookImage({
          base64,
          preview: { type: mimeType },
        });

        // ✅ Update form data with image
        setFormData((prev) => ({
          ...prev,
          book_image: base64,
        }));
      }

      // ✅ Even if no image found, the base form data is already set
    } catch (error) {
      console.error("Error fetching Dharohar images:", error);
    } finally {
      setBackDrowLoading(false);
    }
  };

  const fetchPodcasts = async () => {
    try {
      setLoading(true);
      const res = await configServ.getPodcastsByCompanyandCatergory({
        company_id: company_id,
        category_id: category_id,
      });
      if (res.success) {
        setPodcastList(res.data);
      } else {
        console.error("Failed to fetch podcasts:", res.data.message);
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPodcastUser = async () => {
    try {
      setBackDrowLoading(true);
      const res = await configServ.getResourceMasterUserByCompany(company_id);
      if (res.success) {
        setPodcastUser(res.data); // make sure you have state: const [podcastList, setPodcastList] = useState([]);
      } else {
        console.error("Failed to fetch podcasts:", res.data.message);
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setBackDrowLoading(false);
    }
  };
  useEffect(() => {
    if (isCreate) {
      fetchPodcastUser();
    }
  }, [isCreate]);

  // 🔹 useEffect only calls the function
  useEffect(() => {
    if (company_id) {
      fetchPodcasts();
    }
  }, [company_id]);
  const highlightMatch = (text, query) => {
    try {
      const words = query.toLowerCase().split(" ").filter(Boolean);
      const regex = new RegExp(`(${words.join("|")})`, "gi");

      return text.split(regex).map((part, index) =>
        words.includes(part.toLowerCase()) ? (
          <mark key={index} style={{ backgroundColor: "#ffe58f" }}>
            {part}
          </mark>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        )
      );
    } catch (e) {
      console.error("Error in highlightMatch:", e);
      return text;
    }
  };

  // Inside your component
  const handleDelete = (id, data) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete the podcast.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        configServ
          .deleteResourceDetails(id, data)
          .then((res) => {
            if (res.success) {
              Swal.fire({
                icon: "success",
                title: "Deleted!",
                text: res.message || "Podcast has been deleted.",
                timer: 2000,
                showConfirmButton: false,
              });
              fetchPodcasts();
            }
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: err.response?.data?.message || "Failed to delete podcast.",
            });
          });
      }
    });
  };

  //  download pdf or image
  const handleDownload = async (id) => {
    setBackDrowLoading(true);

    try {
      const res = await configServ.getBookImagesByResourceIdServer({ id });

      if (!res?.success || !res.data || res.data.length === 0) {
        toast.error("No file found.");
        return;
      }

      const file = res.data[0];
      const fileUrl = file.image_url; // direct URL

      if (!fileUrl) {
        toast.error("File URL missing.");
        return;
      }

      // 🔥 Open PDF/Image in new tab
      window.open(fileUrl, "_blank");

      toast.success("Opening file...");
    } catch (error) {
      console.error("Error in handleDownload:", error);
      toast.error("Failed to open file.");
    } finally {
      setBackDrowLoading(false);
    }
  };

  // 🔹 Convert file to Base64 (reusable)
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  // 🔹 Main upload handler (Image or PDF)
  const handleMainFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    // Allowed MIME types
    const allowedMimes = [
      "application/pdf",
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/gif",
      "image/webp",
    ];

    // MIME validation
    if (!allowedMimes.includes(file.type)) {
      toast.error("Only PDF and Image files are allowed");
      return;
    }

    // Size limit (150MB)
    const maxSize = 10 * 1024 * 1024; // 10 MB
    if (file.size > maxSize) {
      toast.error("File must be less than 10MB");
      return;
    }

    const base64 = await toBase64(file);
    setBookImage({ preview: file, base64 });
    setFormData((prev) => ({ ...prev, book_image: base64 }));
  };

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedData, setSelectedData] = useState(null);

  const handleOpenFileNameDialog = (id, data) => {
    setSelectedId(id);
    setSelectedData(data);
    setDialogOpen(true);
  };

  const handleSaveFile = async (fileName) => {
    try {
      if (!fileName?.trim()) {
        toast.error("Please enter a valid file name");
        return;
      }

      const payload = {
        podcast_id: selectedId,
        image_path: fileName,
      };

      const res = await configServ.savePdfFile(payload);

      if (res?.status || res?.success) {
        toast.success("Saved successfully");
        setDialogOpen(false);
      } else {
        toast.error(res?.message || "Something went wrong");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error saving file");
    }
  };

  return (
    <>
      {/* <FileNameDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onSave={handleSaveFile}
      /> */}

       <UploadPdfDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        podcastId={selectedId}
        onSuccess={fetchPodcasts}
        url="/api/upload-chunk-dharohar"
      />
      <LoaderBackdrop open={backDrowLoading} />
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Dharohar"}
        handlePopup={handlePopup}
        create={isCreate}
        isEdit={isEdit}
      />

      {isCreate && (
        <motion.div
          style={{
            width: "100%",
            backgroundColor: "#e3f3fc",
            padding: 20,
            borderRadius: "10px",
          }}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.1, delay: 0.1 }}
        >
          <Grid container spacing={2}>
            {/* Name */}
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                size="small"
                label="Dharohar Title"
                name="name"
                onChange={handleChange}
                value={formData.name || ""}
                sx={{ backgroundColor: "white" }}
                error={!!validationErrors.name}
                helperText={validationErrors.name}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                disablePortal
                fullWidth
                size="small"
                id="podcaster_id"
                name="podcaster_id"
                options={podcastUser}
                getOptionLabel={(option) => option.name || ""}
                filterOptions={(options, { inputValue }) => {
                  const words = inputValue
                    .toLowerCase()
                    .split(" ")
                    .filter(Boolean);
                  return options.filter((user) =>
                    words.every((word) =>
                      user.name.toLowerCase().includes(word)
                    )
                  );
                }}
                sx={{ background: "white" }}
                value={
                  podcastUser.find(
                    (user) => user.id === formData.podcaster_id
                  ) || null
                }
                onChange={(event, newValue) => {
                  if (newValue) {
                    setFormData((prev) => ({
                      ...prev,
                      podcaster_id: newValue.id,
                      url: newValue.web_url || "", // 👈 yahan se URL set hoga
                    }));
                  }
                }}
                renderInput={(params) => {
                  const inputValue = params.inputProps.value || "";
                  const doesNotMatchOption =
                    inputValue &&
                    !podcastUser.some((user) =>
                      inputValue
                        .toLowerCase()
                        .split(" ")
                        .filter(Boolean)
                        .every((word) => user.name.toLowerCase().includes(word))
                    );

                  return (
                    <Box display="flex" alignItems="center" width="100%">
                      <TextField
                        {...params}
                        label="Editor Name"
                        name="podcaster_id"
                        onChange={(e) => {
                          handleChange(e); // aapka existing input change handler
                        }}
                        error={!!validationErrors.podcaster_id}
                        fullWidth
                      />
                      {doesNotMatchOption && (
                        <IconButton
                          color="primary"
                          onClick={() =>
                            navigate("/transaction-entry/resource-master")
                          }
                        >
                          <AddCircleIcon />
                        </IconButton>
                      )}
                    </Box>
                  );
                }}
                renderOption={(props, option, { inputValue }) => (
                  <li {...props}>
                    <Typography variant="body2">
                      {highlightMatch(option?.name, inputValue)}
                    </Typography>
                  </li>
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                size="small"
                label="Dharohar Url"
                name="podcast_url"
                onChange={handleChange}
                value={formData.podcast_url || ""}
                sx={{ backgroundColor: "white" }}
                error={!!validationErrors.podcast_url}
                helperText={validationErrors.podcast_url}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                size="small"
                label="Web Url"
                name="url"
                onChange={handleChange}
                value={formData.url || ""}
                sx={{ backgroundColor: "white" }}
                error={!!validationErrors.url}
                helperText={validationErrors.url}
                disabled // 👈 ye add karna hai
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Box textAlign="center">
                {/* ✅ Label above the upload box */}
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 1, fontWeight: 600, color: "text.primary" }}
                >
                  Upload Image / PDF
                </Typography>

                {bookImage ? (
                  <Box position="relative" display="inline-block">
                    {/* 🔹 If PDF — show PDF icon, else show image preview */}
                    {bookImage.preview.type === "application/pdf" ? (
                      <Box
                        width={90}
                        height={90}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        border="1px solid #ccc"
                        borderRadius={2}
                        sx={{ backgroundColor: "#f5f5f5" }}
                      >
                        📄
                      </Box>
                    ) : (
                      <img
                        src={bookImage.base64}
                        alt="Uploaded"
                        width={90}
                        height={90}
                        style={{
                          borderRadius: "8px",
                          objectFit: "cover",
                          border: "1px solid #ccc",
                        }}
                      />
                    )}

                    {/* ❌ Remove button */}
                    <IconButton
                      size="small"
                      color="error"
                      sx={{
                        position: "absolute",
                        top: -10,
                        right: -10,
                        background: "white",
                      }}
                      onClick={() => {
                        setBookImage(null);
                        setFormData((prev) => ({
                          ...prev,
                          book_image: null,
                        }));
                      }}
                    >
                      ✕
                    </IconButton>
                  </Box>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      sx={{
                        width: 90,
                        height: 90,
                        borderRadius: 2,
                        borderColor: validationErrors.bookImage
                          ? "error.main"
                          : "grey.400",
                      }}
                    >
                      +
                      <input
                        type="file"
                        accept="image/*,.pdf"
                        hidden
                        onChange={handleMainFileUpload}
                      />
                    </Button>

                    {/* 🔹 Show validation error below upload box */}
                    {/* {validationErrors.bookImage && (
                      <Typography
                        variant="caption"
                        color="error"
                        display="block"
                        sx={{ mt: 0.5 }}
                      >
                        {validationErrors.bookImage}
                      </Typography>
                    )} */}
                  </>
                )}
              </Box>
            </Grid>
            {/* Active Status */}
            <Grid item xs={12} md={3}>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={formData.active}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          active: e.target.checked,
                        }))
                      }
                      name="active"
                    />
                  }
                  label="Active"
                />
              </FormGroup>
            </Grid>
            {download_file && (
              <Grid item xs={2} md={3}>
                <IconButton
                  component="a"
                  href={download_file}
                  target="_blank"
                  rel="noopener noreferrer"
                  size="small"
                  sx={{
                    color: "primary.main",
                  }}
                >
                  <DownloadForOfflineIcon />
                </IconButton>
              </Grid>
            )}
          </Grid>

          {/* Buttons */}
          <Grid container spacing={2} justifyContent="flex-end" mt={2}>
            <Grid item>
              <Button
                onClick={clear}
                variant="contained"
                color="secondary"
                startIcon={<RotateLeftIcon />}
              >
                Reset
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={handleSubmit}
                variant="contained"
                color={isEdit ? "success" : "primary"}
                startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
              >
                {isEdit ? "Update" : "Save"}
              </Button>
            </Grid>
          </Grid>
        </motion.div>
      )}

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mt: 2,
          width: "100%",
          gap: 1,
        }}
      >
        <TextField
          select
          size="small"
          value={searchField}
          onChange={(e) => setSearchField(e.target.value)}
          sx={{ minWidth: 120, backgroundColor: "white" }}
        >
          <MenuItem value="name">Name</MenuItem>
        </TextField>

        <TextField
          size="small"
          placeholder={`Search by ${searchField}...`}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{ width: 250, backgroundColor: "white" }}
        />
      </Box>

      {/* 🔹 Mobile Card View */}
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : podcastList.length === 0 ? (
        <Box sx={{ textAlign: "center", mt: 4, color: "text.secondary" }}>
          No podcasts found
        </Box>
      ) : (
        <>
          {/* 🔹 Mobile Card View */}
          <Box
            sx={{ mt: 2, width: "100%", display: { xs: "block", sm: "none" } }}
          >
            <Grid container spacing={2}>
              {podcastList
                .filter((item) => {
                  const value = (item[searchField] || "")
                    .toString()
                    .toLowerCase();
                  return value.includes(searchQuery.toLowerCase());
                })
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((podcast) => (
                  <Grid item xs={12} key={podcast.id}>
                    <Paper
                      elevation={3}
                      sx={{
                        p: 3,
                        borderRadius: 3,
                        backgroundColor: "#fff",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        minHeight: 220,
                        boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
                        },
                      }}
                    >
                      {/* Shastri / Vastu Details */}
                      <Box sx={{ textAlign: "center" }}>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 600,
                            mb: 0.5,
                            color: "text.primary",
                          }}
                        >
                          {podcast.podcaster_name}
                        </Typography>

                        <Typography variant="body2" color="text.secondary">
                          <strong>Dharohar Title:</strong> {podcast.name}
                        </Typography>

                        <Typography
                          variant="body2"
                          sx={{
                            mt: 1,
                            textAlign: "center",
                            color: "text.secondary",
                            wordBreak: "break-word",
                          }}
                        >
                          <strong>URL:</strong> {podcast.url}
                          <br />
                          <strong>Web URL:</strong> {podcast.web_url}
                          <IconButton
                            color="primary"
                            size="small"
                            onClick={() =>
                              window.open(podcast.podcast_url, "_blank")
                            }
                            sx={{ ml: 1 }}
                          >
                            <OpenInNewIcon fontSize="small" />
                          </IconButton>
                        </Typography>

                        <Chip
                          label={podcast.active ? "Active" : "Inactive"}
                          color={podcast.active ? "success" : "default"}
                          size="small"
                          sx={{ mt: 2 }}
                        />
                      </Box>

                      {/* Action Buttons - Bottom Right */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: 1.5,
                          mt: 2,
                          pt: 2,
                          borderTop: "1px solid #eee",
                        }}
                      >
                        <IconButton
                          color="primary"
                          onClick={() => onEdit(podcast)}
                          sx={{
                            backgroundColor: "#e3f2fd",
                            "&:hover": { backgroundColor: "#bbdefb" },
                          }}
                        >
                          <Edit fontSize="small" />
                        </IconButton>
                        <IconButton color="right">
                          <Download
                            fontSize="small"
                            onClick={() => handleDownload(podcast.id, podcast)}
                          />
                        </IconButton>

                        <IconButton
                          color="error"
                          onClick={() => handleDelete(podcast.id, podcast)}
                          sx={{
                            backgroundColor: "#ffebee",
                            "&:hover": { backgroundColor: "#ffcdd2" },
                          }}
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                        <IconButton
                          color="primary"
                          onClick={() =>
                            handleOpenFileNameDialog(podcast.id, podcast)
                          }
                          sx={{
                            backgroundColor: "#ebfeffff",
                            "&:hover": { backgroundColor: "#25d1baff" },
                          }}
                        >
                          <CloudUploadIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Paper>
                  </Grid>
                ))}
            </Grid>

            <TablePagination
              component="div"
              count={podcastList.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>

          {/* 🔹 Desktop Table View */}
          <Box
            sx={{ mt: 2, width: "100%", display: { xs: "none", sm: "block" } }}
          >
            <TableContainer component={Paper}>
              <Table>
                <TableHead sx={{ backgroundColor: "#1976d2" }}>
                  <TableRow>
                    <TableCell sx={{ color: "#fff" }}>S.No.</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Editor Name</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Dharohar Title</TableCell>
                    <TableCell sx={{ color: "#fff" }}>URL</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Web Url</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Status</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Date</TableCell>
                    <TableCell sx={{ color: "#fff" }} align="right">
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {podcastList
                    .filter((item) => {
                      const value = (item[searchField] || "")
                        .toString()
                        .toLowerCase();
                      return value.includes(searchQuery.toLowerCase());
                    })
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((podcast, index) => (
                      <TableRow key={podcast.id}>
                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell>{podcast.podcaster_name}</TableCell>
                        <TableCell>{podcast.name}</TableCell>
                        <TableCell>{podcast.url}</TableCell>
                        <TableCell>{podcast.web_url}</TableCell>

                        <TableCell>
                          <Chip
                            label={podcast.active ? "Active" : "Inactive"}
                            color={podcast.active ? "success" : "default"}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          {new Date(podcast.created_at).toLocaleString(
                            "en-IN",
                            {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              // hour: "2-digit",
                              // minute: "2-digit",
                            }
                          )}
                        </TableCell>
                        <TableCell align="right">
                          <IconButton
                            color="primary"
                            onClick={() => onEdit(podcast)}
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                          <IconButton color="error">
                            <Delete
                              fontSize="small"
                              onClick={() => handleDelete(podcast.id, podcast)}
                            />
                          </IconButton>
                          <IconButton color="right">
                            <Download
                              fontSize="small"
                              onClick={() =>
                                handleDownload(podcast.id, podcast)
                              }
                            />
                          </IconButton>
                          <IconButton
                            color="primary"
                            onClick={() =>
                              handleOpenFileNameDialog(podcast.id, podcast)
                            }
                            sx={{
                              backgroundColor: "#ebfeffff",
                              "&:hover": { backgroundColor: "#c9ece8ff" },
                            }}
                          >
                            <CloudUploadIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                count={podcastList.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          </Box>
        </>
      )}
    </>
  );
};

export default Dharohar;
